module.exports = __webpack_public_path__ + "assets/img/desktop_main_image.782d8f50.jpg";